import React, { useState, useEffect } from 'react';
import * as identity from '../controller/identity';
import { Link } from "react-router-dom";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBooks} from '@fortawesome/pro-duotone-svg-icons';

import { useLocation } from 'react-router-dom'

export interface INavigationViewProps {
    onClickChangePassword?: () => void;
    identity?: identity.IIdentity;
}

export const Navigation: React.FunctionComponent<INavigationViewProps> = (props) => {

    const [showNavigation, setShowNavigation] = useState(false);

    // Close burger on navigation
    let location = useLocation();
    useEffect(() => setShowNavigation(false), [location]);

    function toggleMenu(e: React.MouseEvent<HTMLButtonElement>) {
        setShowNavigation(!showNavigation);
    }

    const topnav: any[] = [];
    let button: JSX.Element | undefined;

    if (props.identity) {
        const coursesTarget = location.pathname.startsWith('/kurse') ? '/' : '/kurse';
        const coursesLabel = coursesTarget === '/' ? 'Startbereich' : 'Meine Kurse';
        const learningLinks = [
            {
                label: 'Lernablauf',
                href: 'https://www.institut-sitya.at/hubfs/faq/flex-selbststudium/E-Learning_Anleitung_Flex-Fernstudium_SITYA.pdf'
            },
            {
                label: 'Schrittanleitung',
                href: 'https://www.institut-sitya.at/hubfs/Schrittanleitung/Schritt-fuer-Schritt_Lernunterlagen_nutzen_Desktop_Mobil_SITYA.pdf'
            },
            {
                label: 'Lernhilfe',
                href: 'https://www.institut-sitya.at/lernfrage'
            },
            {
                label: 'Videoeinf&uuml;hrung',
                href: 'https://www.institut-sitya.at/persoenlichkeitstraining'
            },
            {
                label: 'FAQ',
                href: 'https://www.institut-sitya.at/faq'
            }
        ];

        button = <button id="hamburger" className={`hamburger hamburger--elastic ${showNavigation ? "is-active" : ""}`} type="button" aria-label="Menu"
            aria-controls="navigation" aria-expanded="false" data-target="topnav" onClick={(e) => toggleMenu(e)}>

            <span style={{ marginRight: "0.5rem" }}>Men&uuml;</span>
            <span className="hamburger-box" style={{ marginBottom: "-6px" }}>
                <span className="hamburger-inner"></span>
            </span>
        </button>;

        learningLinks.forEach((link, index) => {
            topnav.push(
                <a key={`learning-link-${index}`} href={link.href} target="_blank" rel="noreferrer noopener" className="navbar-item">
                    <span dangerouslySetInnerHTML={{ __html: link.label }} />
                </a>
            );
        });

        // Only new users (with a valid mail-address can change their password)
        const chpwd = <span className="menulink link navbar-item translate" data-target="change-password-dialog"
                onClick={(e) => {
                    if (props.onClickChangePassword) props.onClickChangePassword();
                }}>
                Passwort &auml;ndern
            </span>;

        topnav.push(
            <div key="item-account" className="navbar-item has-dropdown is-hoverable">
                <span className="navbar-link is-text translate">
                    Mein Konto
                </span>
                <div className="navbar-dropdown">
                    {chpwd}
                    <Link to="/logout" className="navbar-item" ><span className="translate">Abmelden</span></Link>
                </div>
            </div>
        );

        if (props.identity.role === 'user') {

            topnav.push(
                <div key="item-courses" className="navbar-item course-navigation-item">
                    <Link to={coursesTarget} className="course-navigation-link">
                        <FontAwesomeIcon icon={faBooks} className="course-navigation-icon" />
                        <span className="translate">{coursesLabel}</span>
                    </Link>
                </div>
            );
        }
    }

    return (
        <nav className="navbar" role="navigation" aria-label="main navigation">
            <div className="container">
                <div className="navbar-brand">
                    <Link to="/" className="navbar-item">
                        <img src="/logo-2023.svg" alt="Logo Institut SITYA" />
                    </Link>
                    {button}
                </div>

                <div id="topnav" className={`navbar-menu ${showNavigation ? "is-active" : ""}`} style={{ alignItems: "flex-end" }}>
                    <div className="navbar-end">
                        {topnav}
                    </div>
                </div>
            </div>
        </nav>
    );
}
